<template>
    <v-chip small label class="ml-auto" v-bind:color="color">{{
        label
    }}</v-chip>
</template>

<script>
const NONE_LABEL = 'none';
const DEFAULT_COLOR = 'default';

export default {
    props: {
        settlement: Object
    },
    data() {
        return {
            label: NONE_LABEL,
            color: DEFAULT_COLOR
        };
    },
    watch: {
        settlement() {
            if (null == this.settlement) {
                this.label = NONE_LABEL;
                this.color = DEFAULT_COLOR;
            } else if (this.settlement.is_settled) {
                this.label = 'settled';
                this.color = 'success';
            } else {
                this.label = 'pending';
                this.color = 'warning';
            }
        }
    }
};
</script>
